import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state';
import { ESuburbanWCType } from '../../../../../../../json_query';
import { changeSuburbanWCType } from '../../../../../../state/advanced/suburban_wc';
import { SuburbanBathroom as SuburbanBathroomComponent, ISuburbanBathroomProps } from './suburbanBathroom';

type TSuburbanBathroomStateProps = Pick<ISuburbanBathroomProps, 'value'>;
type TSuburbanBathroomDispatchProps = Pick<ISuburbanBathroomProps, 'onChange'>;

export function mapStateToProps(state: IAppState): TSuburbanBathroomStateProps {
  return {
    value: (state.filters.jsonQuery.wc_site && state.filters.jsonQuery.wc_site.value) || ESuburbanWCType.Any,
  };
}

export function mapDispatchToProps(dispatch: Dispatch): TSuburbanBathroomDispatchProps {
  return {
    onChange: (type: ESuburbanWCType) => {
      dispatch(changeSuburbanWCType(type));
    },
  };
}

export const SuburbanBathroom = connect(mapStateToProps, mapDispatchToProps)(SuburbanBathroomComponent);
